import { render, staticRenderFns } from "./ResturantBranches.vue?vue&type=template&id=6ec42f21&scoped=true&"
import script from "./ResturantBranches.vue?vue&type=script&lang=js&"
export * from "./ResturantBranches.vue?vue&type=script&lang=js&"
import style0 from "./ResturantBranches.vue?vue&type=style&index=0&id=6ec42f21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec42f21",
  null
  
)

export default component.exports